package com.tovtalk.ui.adaptive

import androidx.compose.runtime.Composable

@Composable
fun <T> adaptive(
    compact: T,
    mediumCompact: T = compact,
    medium: T = mediumCompact,
    expanded: T = medium,
    large: T = expanded,
    extraLarge: T = large
): T {
    return when (LocalWindowSizeClass.current) {
        WindowSizeClass.Compact -> compact
        WindowSizeClass.MediumCompact -> mediumCompact
        WindowSizeClass.Medium -> medium
        WindowSizeClass.Expanded -> expanded
        WindowSizeClass.Large -> large
        WindowSizeClass.ExtraLarge -> extraLarge
    }
}

@Composable
fun responsiveGridColumns(
    compact: Int = 3,
    mediumCompact: Int = compact,
    medium: Int = mediumCompact,
    expanded: Int = medium,
    large: Int = expanded,
    extraLarge: Int = large
): Int = adaptive(compact, mediumCompact, medium, expanded, large, extraLarge)

@Composable
fun isCompact(): Boolean = LocalWindowSizeClass.current == WindowSizeClass.Compact

@Composable
fun isMobile(): Boolean = LocalWindowSizeClass.current in setOf(
    WindowSizeClass.Compact,
    WindowSizeClass.MediumCompact
)

@Composable
fun hasRail(): Boolean = LocalWindowSizeClass.current in setOf(
    WindowSizeClass.Medium,
    WindowSizeClass.Expanded
)

@Composable
fun hasDrawer(): Boolean = LocalWindowSizeClass.current in setOf(
    WindowSizeClass.Large,
    WindowSizeClass.ExtraLarge
)

@Composable
fun hasSplitView(): Boolean = !isMobile()

@Composable
fun isExpandedOrMedium(): Boolean = !isMobile()

@Composable
fun isExpanded(): Boolean = LocalWindowSizeClass.current in setOf(
    WindowSizeClass.Expanded,
    WindowSizeClass.Large,
    WindowSizeClass.ExtraLarge
)
